import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { AuftragStatusLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';

interface AuftragStatusProps {
    disabled?: boolean;
    value: string;
    addAll?: boolean;
    renderLabel?: 'label' | 'placeholder' | 'no';
    onChange: (newValue: string) => void;
}

const allOption = { value: '__all__', label: 'Alle' };

export const AuftragStatus: React.FC<AuftragStatusProps> = ({
    value,
    disabled = false,
    renderLabel = 'label',
    onChange,
    addAll = false,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];
        if (addAll) {
            list.push(allOption);
        }

        Object.keys(AuftragStatusLabel).forEach((key) => {
            list.push({
                value: key,
                label: AuftragStatusLabel[key],
            });
        });

        return list;
    }, [addAll]);

    const selectedOption = React.useMemo(() => {
        if (value === '__all__') {
            return allOption;
        }

        if (value) {
            return {
                value,
                label: AuftragStatusLabel[value] || value,
            };
        }

        return {
            value: '',
            label: '',
        };
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>Status</Label>}
            <Select
                name="status"
                isDisabled={disabled}
                value={selectedOption}
                options={options}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '__all__');
                }}
                placeholder={renderLabel === 'placeholder' ? 'Status' : ''}
            />
        </>
    );
};
